import { Space, SpaceRoleType } from '@tribeplatform/gql-client/types'
import { Form } from '@tribeplatform/react-sdk/components'
import { useUpdateSpace } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Divider } from '@tribeplatform/react-ui-kit/Divider'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

const ADMIN_AND_MEMBERS = 'adminAndMembers'
const ADMIN_ONLY = 'adminOnly'

const items = [
  { text: 'Admin and Members', value: ADMIN_AND_MEMBERS },
  { text: 'Admin Only', value: ADMIN_ONLY },
]

export const SpaceSettingsPermissions = ({ space }: { space: Space }) => {
  const { mutateAsync: updateSpace, isLoading } = useUpdateSpace()
  const adminRoleId =
    space?.roles?.find(r => r.type === SpaceRoleType.ADMIN)?.id || ''

  return (
    <>
      <Form
        defaultValues={{
          ...space,
          _private: space?.private,
          whoCanPost:
            space?.whoCanPost?.length > 0 ? ADMIN_ONLY : ADMIN_AND_MEMBERS,
          whoCanReact:
            space?.whoCanReact?.length > 0 ? ADMIN_ONLY : ADMIN_AND_MEMBERS,
        }}
        onSubmit={async data => {
          const {
            whoCanPost,
            whoCanReact,
            _private,
            hidden,
            inviteOnly,
            nonAdminsCanInvite,
          } = data
          try {
            await updateSpace({
              id: space?.id,
              input: {
                whoCanPost: whoCanPost === ADMIN_ONLY ? [adminRoleId] : null,
                whoCanReact: whoCanReact === ADMIN_ONLY ? [adminRoleId] : null,
                whoCanReply: whoCanReact === ADMIN_ONLY ? [adminRoleId] : null,
                private: _private,
                hidden,
                inviteOnly,
                nonAdminsCanInvite,
              },
            })
            toast({
              title: 'Space permissions updated',
              status: 'success',
            })
          } catch (e) {
            toast({
              title: 'Unable to update space permissions',
              status: 'error',
            })
          }
        }}
      >
        <div className="col-span-12 md:col-span-8 flex flex-col space-y-5">
          <h2>Permissions</h2>
          <Form.Toggle
            label="Make private"
            description="Only members can see who's in the space and what they post."
            name="_private"
          />
          <Form.Toggle
            label="Hide space"
            description="Hide this space from non-space members."
            name="hidden"
          />
          <Form.Toggle
            label="Make invite-only"
            description="Allow only people with an invite to join as space members."
            name="inviteOnly"
          />
          <Form.Toggle
            label="Anyone can invite"
            description="Allow non-admin members to invite others to the space."
            name="nonAdminsCanInvite"
          />
          <Divider padding="none" />
          <Form.Select label="Who can post?" name="whoCanPost" items={items} />
          <Form.Select
            label="Who can react and comment?"
            name="whoCanReact"
            items={items}
          />
          <Form.Actions>
            <Button type="submit" loading={isLoading}>
              Update
            </Button>
          </Form.Actions>
        </div>
      </Form>
    </>
  )
}
